import repository from "@/api/modules/MasterData";
import swal from "sweetalert2";

export default {
  state: {
    companies: [],
    default_company: null,
  },
  getters: {
    GET_ALL_COMPANIES: (state) => state.companies,
    GET_DEFAULT_COMPANY: (state) => state.default_company,
  },
  mutations: {
    SET_ALL_COMPANIES(state, data) {
      state.companies = data;
    },
    SET_DEFAULT_COMPANY(state, data) {
      state.default_company = data;
    },
  },
  actions: {
    getCompanies({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getcompanies(payload)
          .then(resolve)
          .catch((error) => {
            reject(error);
            swal.fire({ title: "ERROR", icon: "error" });
          });
      });
    },
    getAllCompanies({ commit }) {
      return new Promise((resolve, reject) => {
        repository
          .getallcompanies()
          .then((response) => {
            commit("SET_ALL_COMPANIES", response.data);
            const def = response.data.find((c) => c.is_default);
            commit("SET_DEFAULT_COMPANY", def || null);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            swal.fire({ title: "ERROR", icon: "error" });
          });
      });
    },
    addCompany({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .addcompany(payload)
          .then(resolve)
          .catch((error) => {
            reject(error);
            swal.fire({ title: "ERROR", icon: "error" });
          });
      });
    },
    updateCompany({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .updatecompany(payload)
          .then(resolve)
          .catch((error) => {
            reject(error);
            swal.fire({ title: "ERROR", icon: "error" });
          });
      });
    },
    deleteCompany({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .deletecompany(payload)
          .then(resolve)
          .catch((error) => {
            reject(error);
            swal.fire({ title: "ERROR", icon: "error" });
          });
      });
    },
    setDefaultCompany({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .setdefaultcompany(payload)
          .then(resolve)
          .catch((error) => {
            reject(error);
            swal.fire({ title: "ERROR", icon: "error" });
          });
      });
    },
  },
};
